import TooltipWrapper from './TooltipWrapper';

export default TooltipWrapper;
